import { render, staticRenderFns } from "./UltralocalOfficeProcessing.vue?vue&type=template&id=2bd8cc0f&scoped=true"
import script from "./UltralocalOfficeProcessing.vue?vue&type=script&lang=js"
export * from "./UltralocalOfficeProcessing.vue?vue&type=script&lang=js"
import style0 from "./UltralocalOfficeProcessing.vue?vue&type=style&index=0&id=2bd8cc0f&prod&scoped=true&lang=css"
import style1 from "./UltralocalOfficeProcessing.vue?vue&type=style&index=1&id=2bd8cc0f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd8cc0f",
  null
  
)

export default component.exports